import axios from 'axios'
import { ElMessage } from 'element-plus'

// 从WordPress全局变量获取配置
const getSettings = () => {
  if (typeof window !== 'undefined' && window.amjVueSettings) {
    return window.amjVueSettings
  }
  return {
    restUrl: '/wp-json/amj/v1/',
    nonce: ''
  }
}

// 创建axios实例
const api = axios.create({
  baseURL: getSettings().restUrl,
  timeout: 60000,
  headers: {
    'Content-Type': 'application/json',
    'X-WP-Nonce': getSettings().nonce
  }
})

// 请求拦截器
api.interceptors.request.use(
  (config) => {
    // 更新nonce（可能在运行时变化）
    const settings = getSettings()
    config.headers['X-WP-Nonce'] = settings.nonce
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// 响应拦截器
api.interceptors.response.use(
  (response) => {
    return response.data
  },
  (error) => {
    const message = error.response?.data?.message || error.message || '请求失败'
    ElMessage.error(message)
    return Promise.reject(error)
  }
)

export default api
